import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeThree/K6501.png'
import _imports_1 from '@/assets/themetwo/Close_02-1.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "text1" }
const _hoisted_3 = { class: "text2" }
const _hoisted_4 = { style: {"padding":"0 20px"} }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { style: {"padding":"0 20px"} }
const _hoisted_7 = { class: "detailsBg" }
const _hoisted_8 = { class: "infoText" }
const _hoisted_9 = { style: {"padding":"15px"} }
const _hoisted_10 = { class: "title2" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "introCard" }
const _hoisted_13 = { class: "title3" }
const _hoisted_14 = { class: "installInfo2" }

import { ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useUserStore } from '@/stores/user';

export default /*@__PURE__*/_defineComponent({
  __name: 'pwaStatusPopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()

const open = (value: string) => {
    show.value = true
    title.value = value
    userStore.setPwaShowing(false)
}


const close = () => {
    show.value = false
    // contactRef.value.close()
    userStore.setPwaShowing(false)
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const openContactPopup = () => {
    contactRef.value.open()
}

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onClickOverlay: close,
      position: "bottom",
      style: {
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_row, { class: "headBar" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "5" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "logo" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    })
                  ], -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "15",
                style: {"padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pwa.text3')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('pwa.text2')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "2",
                offset: "2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", { class: "closeIcon" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "",
                      onClick: close
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pwa.title')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(title.value), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('pwa.installIntroTitle')), 1),
            _createElementVNode("div", {
              class: "installInfo",
              innerHTML: _ctx.$t('pwa.installIntro1')
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('pwa.installIntroTitle')), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('pwa.installIntro2')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})